import React, { useEffect } from "react";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import styled from "styled-components";
import LogController from "../../controller/LogController";
import { qrAuthState } from "../../recoil/auth";
import { langState, langText } from "../../recoil/lang";
import "../../styles/CustomModal.css";

const OrderCancelModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  cancel_description: string;
}) => {
  const auth = useRecoilValue(qrAuthState);
  const navigate = useNavigate();
  const [lang, setLang] = useRecoilState<number>(langState);

  const navigateStatus = () => {
    onCloseModal();
    if (auth.refresh_token === "") navigate("/status");
    else navigate("/status");
  };

  const onCloseModal = () => {
    oProps.setVisible(false);
    LogController.click({
      path: "OrderCancelModal",
      params: "cancel",
      params2: "사용자가 주문취소 모달 닫음",
    });
  };

  useEffect(() => {
    if (oProps.isVisible) {
      LogController.event({
        path: "OrderCancelModal",
        params: "cancel",
        params2: "주문취소 모달 열림",
      });
    }
  }, [oProps.isVisible]);

  return (
    <Modal
      isOpen={oProps.isVisible}
      onRequestClose={onCloseModal}
      className="arrivalModal modal-content"
      closeTimeoutMS={100}
      shouldCloseOnOverlayClick={false}
      ariaHideApp={false}
    >
      <Style>
        <div className="modal">
          <img
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_cancel_red.svg`}
            alt="ic"
          />
          <img
            className="closeIcon"
            onClick={onCloseModal}
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close_black.svg`}
            alt="ic"
          />
          <div>
            <p className="titleFont">{`${langText.orderCancelModal_title[lang]}`}</p>
            {/* <p className="titleFont">{`${
              langText.orderCancelModal_reason[lang]
            }: ${contentName(oProps.cancel_description, lang)}`}</p> */}
          </div>

          <div className="confirmButton" onClick={navigateStatus}>
            {langText.orderCancelModal_button_submit[lang]}
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default OrderCancelModal;

const Style = styled.div`
  img {
    padding-bottom: 10px;
  }
  .modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 8%;
    width: 100%;
    height: 100%;
    position: relative;
  }
  .closeIcon {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 40px;
  }
  .titleFont {
    width: 100%;
    font-size: 20px;
    line-height: 32px;
    font-weight: 400;
    color: #000000;
    text-align: center;
    margin: 0;
    white-space: pre;
  }
  .confirmButton {
    width: 90%;
    margin-top: 20px;
    padding: 16px;
    background: #ff4a4a;
    font-size: 24px;
    line-height: 32px;
    border-radius: 10px;
    color: #ffffff;
    font-weight: 600;
    text-align: center;
  }

  @media (max-width: 700px) {
    img {
      padding-bottom: 0;
    }
    .closeIcon {
      width: 24px;
      right: 12px;
      top: 12px;
    }
    .modal {
      gap: 20px;
    }
    .titleFont {
      font-size: 14px;
      line-height: 22px;
      font-weight: 500;
      color: #555555;
    }
    .confirmButton {
      width: 100%;
      margin: 0;
      padding: 10px;
      background: #ff4a4a;
      font-size: 20px;
    }
  }
`;
